export default "__VITE_ASSET__DVgD8rtY__"